
import React, { useEffect, useState } from "react";
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useNavigate } from 'react-router-dom';
import './Greeter.css';
import GreeterAdd from './GreeterAdd';
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { PostData } from "../API/postApi";
import SunspotLoader from "../sharedFiles/loader/loader";
import { useInputFieldsConfig } from "./GreeterUtlits";
import { selectUser } from "../ReduxStore/userReducer";
import { getGreeterCust, GetGreeterSection, GetSalesPerson, GreeterPostDetails } from "../API/Greeter/GreeterThunk";
function Greeter() {
  const inputFields = useInputFieldsConfig();
  const userData = useSelector(selectUser);
  const databaseName = userData?.DatabaseName;
  const [callInprogress, setCallInprogress] = useState({
    getsalesPerson: false, getsection: false, postGreeterData: false, getcustomer: false
  })
  const { GetGreeterCustData, GreeterSectionData, GetSalesPersonData, PostGreeter, loading, error } = useSelector(state => state.greeterData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getInitialValues = (fields) =>
    fields.reduce((acc, field) => ({ ...acc, [field.name]: '' }), {});
  const [values, setValues] = useState(() => getInitialValues(inputFields))
  const [dropdownVisibility, setDropdownVisibility] = useState(() => inputFields.reduce((acc, field) => ({ ...acc, [field.name]: false }), {}));
  const [suggestions, setSuggestions] = useState([]);
  const [focusedField, setFocusedField] = useState(null);
  const isSubmitEnabled = () => {
    const requiredFields = ['name', 'phnumber', 'section', 'slp', 'slpCode'];
    return requiredFields.every(field => values[field] && values[field].toString().trim() !== '');
  };
  
  useEffect(() => {
    if (!GetSalesPersonData) {
      setCallInprogress(prev => ({ ...prev, getsalesPerson: true }));
      dispatch(GetSalesPerson({ databaseName }));
    }
    if (!GreeterSectionData) {
      setCallInprogress(prev => ({ ...prev, getsection: true }));
      dispatch(GetGreeterSection());
    }
  }, [dispatch]);

  // useEffect(() => {
  //   if (GetGreeterCustData && GetGreeterCustData.length > 0) {
  //     setSuggestions(GetGreeterCustData);
  //   }
  // }, [GetGreeterCustData]);

  const isLoading = () => {
    return (
      // loading.GetGreeterCustData ||
      loading.GetSalesPersonData ||
      loading.GreeterSectionData ||
      loading.PostGreeter
    );
  };

  const responseChecker = () => {
     if(callInprogress.postGreeterData &&error.PostGreeterError) {
    toast.success(error.PostGreeterError);
    setCallInprogress(prev => ({ ...prev, postGreeterData: false }));
  } if (callInprogress.postGreeterData && PostGreeter === 'OK') {
      toast.success('Greeter Posted Successfully');
      setCallInprogress(prev => ({ ...prev, postGreeterData: false }));
      setValues(getInitialValues(inputFields));
    }

    if (callInprogress.getsalesPerson && error.GetSalesPersonError) {
      toast.error(error.GetSalesPersonError);
      setCallInprogress(prev => ({ ...prev, getsalesPerson: false }));
    }

    if (callInprogress.getcustomer && GetGreeterCustData && GetGreeterCustData.length > 0) {
      setSuggestions(GetGreeterCustData);
      setCallInprogress(prev => ({ ...prev, getcustomer: false }));
    } else if (callInprogress.getcustomer && error.GetGreeterCustError) {
      // toast.error(error.GetGreeterCustError);
    }

    if (callInprogress.getsection) {
      if (error.GreeterSectionError) {
        toast.error(error.GreeterSectionError);
        setCallInprogress(prev => ({ ...prev, getsection: false }));
      };
    }
  }
  useEffect(() => {
    responseChecker();
  }, [PostGreeter, error, GetGreeterCustData, callInprogress, inputFields]);

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    const { name, filterKey, dataSourceKey } = field;
    setValues(prev => ({ ...prev, [name]: value }));
    if (
      // name === 'name' ||
      name === 'phnumber') {
        if (field.field === "PhoneNo" && (!/^\d*$/.test(value) || value.length > 10)) {
          return; 
        }
      if (value.length >= 2) {
        setCallInprogress(prev => ({ ...prev, getcustomer: true }));
        dispatch(getGreeterCust({ dbName: databaseName, SearchText: value }));
      }
      setDropdownVisibility(prev => ({ ...prev, [name]: true }));
    } else if (Array.isArray(dataSourceKey)) {
      const filtered = dataSourceKey.filter(item =>
        item[filterKey]?.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
      setDropdownVisibility(prev => ({ ...prev, [name]: true }));
    } else {
      setSuggestions([]);
    }
  };

  const handleSubmit = async () => {
    const postData = [{
      customerName: values.name,
      customerCode: values?.CustomerCode,
      phoneNumber: values.phnumber,
      categoryType: values.section,
      slpName: values.slp,
      slpCode: values.slpCode,
      status: "open",
      assignDateTime: new Date().toISOString(),
      closingDateTime: new Date().toISOString(),
    }];

    try {
      setCallInprogress({ ...callInprogress, postGreeterData: true })
      dispatch(GreeterPostDetails(postData))
    } catch (err) {
      toast.error(err.message || "An error occurred");
    }
  };
  const handleBack=()=>{
    navigate("/DashBoard")
  }
  return (
    <>
      <Header />
      <div className="dashBoardMain">
        <div className="dashImage"></div>
        <div className="dashGradient"></div>
        <div className='Greeterdiv'>
          <div className="GreeterTopDiv">
            <button className="backIcondiv" onClick={handleBack}>
              <ArrowCircleLeftIcon />
              <span className='DashBoardName'>Dashboard</span>
            </button>
          </div>
          <div className="greeterFields">
            <div className="col-12 col-md-6 col-lg-4 mt-5">
              <GreeterAdd
                inputFields={inputFields}
                values={values}
                setValues={setValues}
                dropdownVisibility={dropdownVisibility}
                handleInputChange={handleInputChange}
                setDropdownVisibility={setDropdownVisibility}
                suggestions={suggestions}
                setSuggestions={setSuggestions}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
              <div className="d-flex justify-content-center">
                <button
                  onClick={handleSubmit}
                  disabled={!isSubmitEnabled()}
                  className="btn btn-primary w-50 mt-3"
                >
                  Submit
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer position="bottom-right" theme="dark" />
      {isLoading() && (
        <div className="loader position-absolute">
          <SunspotLoader />
        </div>
      )}
    </>
  );
}

export default Greeter;

